export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";